import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  action?: { to: string; label: string };
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  action,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div
      className={`flex flex-col gap-4 md:flex-row md:items-end md:justify-between ${
        isCenter ? "md:flex-col md:items-center md:text-center" : ""
      }`}
    >
      <div className={isCenter ? "flex flex-col items-center" : ""}>
        <p className="flex items-center gap-2 text-xs tracking-[0.3em] text-accent-500">
          <span className="inline-block h-px w-6 bg-accent-600" />
          {eyebrow}
        </p>
        <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-[34px] md:leading-tight">
          {title}
        </h2>
        {description && (
          <p className={`mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 ${isCenter ? "mx-auto" : ""}`}>
            {description}
          </p>
        )}
      </div>
      {action && !isCenter && (
        <Link
          to={action.to}
          className="group flex items-center gap-2 whitespace-nowrap text-sm text-foreground-700 transition-colors duration-200 hover:text-accent-400 cursor-pointer"
        >
          {action.label}
          <i className="ri-arrow-right-line text-base transition-transform duration-200 group-hover:translate-x-1" />
        </Link>
      )}
    </div>
  );
}